/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvD042k%7Bborder-radius%3Avar(--ds-radius-tile%2C5px)%7D%0A._2sNsIg7NXe%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._37wbyuDIqT%7Bjustify-content%3Acenter%7D%0A._3YEZNOdnbC%7Bflex-shrink%3A0%7D%0A._39xV02SPN1%7Bwidth%3A20px%7D%0A._0jFU0VSPN1%7Bheight%3A20px%7D%0A._1kk5Tkf7mX%7Bfont-weight%3Avar(--ds-font-weight-medium%2C500)%7D%0A._0bjKvDy67O%7Bborder-radius%3Avar(--ds-radius-tile%2C6px)%7D%0A._39xV02oWWg%7Bwidth%3A24px%7D%0A._0jFU0VoWWg%7Bheight%3A24px%7D%0A._0bjKvDBSbZ%7Bborder-radius%3Avar(--ds-radius-tile%2C8px)%7D%0A._2sNsIgmnOE%7Bfont%3Avar(--ds-font-body%2Cnormal%20400%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._39xV02Uofl%7Bwidth%3A2pc%7D%0A._0jFU0VUofl%7Bheight%3A2pc%7D%0A._0bjKvDX7GY%7Bborder-radius%3Avar(--ds-radius-tile%2C9pt)%7D%0A._2sNsIgxzFw%7Bfont%3Avar(--ds-font-heading-large%2Cnormal%20653%2024px%2F28px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._39xV02pJKa%7Bwidth%3A3pc%7D%0A._0jFU0VpJKa%7Bheight%3A3pc%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._49OCfRdnbC%7Binset%3A0%7D%0A._1mT5xdWVPG%7Bposition%3Aabsolute%7D%0A._2V7sgONvrM%7Bborder-width%3Avar(--ds-border-width%2C1px)%7D%0A._3hxITi6wH8%7Bborder-style%3Asolid%7D%0A._3vBAKHtT36%7Bborder-color%3Avar(--ds-border%2C%23091e4224)%7D%0A._1llTr6MFyn%7Bfilter%3Agrayscale(1)%7D%0A._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D%0A._0EnhYgdnbC%3Aafter%7Binset%3A0%7D%0A._2Gfj6iOLYo%3Aafter%7Bborder-radius%3Ainherit%7D%0A._0GBAIrogpp%3Aafter%7Bcontent%3A%22%22%7D%0A._2WYcYGWVPG%3Aafter%7Bposition%3Aabsolute%7D%0A._3wEj0XKcZT%3Aafter%7Bbackground-color%3Avar(--ds-background-neutral-hovered%2C%230b120e24)%7D%0A._0KLXruB8KG%7Bbackground-color%3Avar(--ds-background-accent-purple-subtlest%2C%23f8eefe)%7D%0A._0KLXruVva3%7Bbackground-color%3Avar(--ds-background-accent-blue-subtlest%2C%23e9f2fe)%7D%0A._0KLXruXL80%7Bbackground-color%3Avar(--ds-background-accent-lime-subtlest%2C%23efffd6)%7D%0A._0KLXru56u3%7Bbackground-color%3Avar(--ds-background-accent-yellow-subtlest%2C%23fef7c8)%7D%0A._0KLXrueJK9%7Bbackground-color%3Avar(--ds-background-accent-purple-subtlest-hovered%2C%23eed7fc)%7D%0A._0KLXruotmK%7Bbackground-color%3Avar(--ds-background-accent-blue-subtlest-hovered%2C%23cfe1fd)%7D%0A._0KLXruL7r8%7Bbackground-color%3Avar(--ds-background-accent-lime-subtlest-hovered%2C%23d3f1a7)%7D%0A._0KLXruBwZU%7Bbackground-color%3Avar(--ds-background-accent-yellow-subtlest-hovered%2C%23f5e989)%7D%0A._1UtDYzXCFT%7Bcolor%3Avar(--ds-text-accent-purple-bolder%2C%2348245d)%7D%0A._1UtDYz802h%7Bcolor%3Avar(--ds-text-accent-blue-bolder%2C%23123263)%7D%0A._1UtDYzfXoY%7Bcolor%3Avar(--ds-text-accent-lime-bolder%2C%2337471f)%7D%0A._1UtDYzD7aB%7Bcolor%3Avar(--ds-text-accent-yellow-bolder%2C%23533f04)%7D");














































import React, { useState } from 'react';
import AvatarSkeleton from '@atlaskit/avatar/skeleton';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { resolveIconSources } from './icon-sources';
import type { UnitTileProps, UnitTileSize } from './types';
import { getAbbreviation, getVariant } from './utils';

// ─── Shared ──────────────────────────────────────────────────────────────────
const boxStyles = {
  xsmall: "_0bjKvD042k _2sNsIg7NXe _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _39xV02SPN1 _0jFU0VSPN1 _1kk5Tkf7mX",
  small: "_0bjKvDy67O _2sNsIg7NXe _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _39xV02oWWg _0jFU0VoWWg _1kk5Tkf7mX",
  medium: "_0bjKvDBSbZ _2sNsIgmnOE _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _39xV02Uofl _0jFU0VUofl _1kk5Tkf7mX",
  large: "_0bjKvDX7GY _2sNsIgxzFw _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _39xV02pJKa _0jFU0VpJKa _1kk5Tkf7mX"
};
const FALLBACK_TESTID = 'unit-tile';
const sandboxUnitStyles = {
  grayscale: "_2V7sgONvrM _3hxITi6wH8 _3vBAKHtT36 _1llTr6MFyn _24h04i2Njc"
};

// ─── UnitTileImage ────────────────────────────────────────────────────────────
const imageHighlightedStyles = {
  overlay: "_1mT5xdRAKS _0EnhYgdnbC _2Gfj6iOLYo _0GBAIrogpp _2WYcYGWVPG _3wEj0XKcZT"
};
const imageLoadingStyles = {
  container: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS",
  overlay: "_49OCfRdnbC _1mT5xdWVPG"
};
interface UnitTileLoadingSkeletonProps {
  size: UnitTileSize;
  testId: string;
}
function UnitTileLoadingSkeleton({
  size,
  testId
}: UnitTileLoadingSkeletonProps) {
  return <Box xcss={cx(boxStyles[size], imageLoadingStyles.container)} testId={`${testId}-loading-skeleton`}>
			<AvatarSkeleton appearance="square" size={size} />
		</Box>;
}
function UnitTileImage({
  unitName,
  size,
  iconUrl,
  isHighlighted,
  isSandboxUnit,
  sizes,
  srcSet,
  testId,
  onError,
  onLoad,
  showLoadingState
}: {
  iconUrl: string;
  isHighlighted?: boolean;
  isSandboxUnit?: boolean;
  onError: () => void;
  onLoad: () => void;
  showLoadingState: boolean;
  size: UnitTileSize;
  sizes?: string;
  srcSet?: string;
  testId: string;
  unitName: string;
}): JSX.Element {
  return <Box xcss={cx(boxStyles[size], imageLoadingStyles.container, isHighlighted ? imageHighlightedStyles.overlay : undefined, isSandboxUnit ? sandboxUnitStyles.grayscale : undefined)} testId={testId}>
			<img src={iconUrl} srcSet={srcSet} sizes={sizes} alt={unitName} onError={onError} onLoad={onLoad}
    /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- borderRadius: inherit requires inline style; cannot use cssMap for inherited values */ style={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: 'inherit',
      opacity: showLoadingState ? 0 : 1
    }} />
			{showLoadingState && <Box xcss={imageLoadingStyles.overlay} testId={`${testId}-loading-skeleton`}>
					<AvatarSkeleton appearance="square" size={size} />
				</Box>}
		</Box>;
}

// ─── UnitTileAbbreviation ─────────────────────────────────────────────────────
const backgroundColorStyles = {
  purple: "_0KLXruB8KG",
  blue: "_0KLXruVva3",
  lime: "_0KLXruXL80",
  yellow: "_0KLXru56u3"
};
const highlightedBackgroundColorStyles = {
  purple: "_0KLXrueJK9",
  blue: "_0KLXruotmK",
  lime: "_0KLXruL7r8",
  yellow: "_0KLXruBwZU"
};
const textColorStyles = {
  purple: "_1UtDYzXCFT",
  blue: "_1UtDYz802h",
  lime: "_1UtDYzfXoY",
  yellow: "_1UtDYzD7aB"
};
function UnitTileAbbreviation({
  unitName,
  size,
  isHighlighted,
  isSandboxUnit,
  testId
}: {
  isHighlighted?: boolean;
  isSandboxUnit?: boolean;
  size: UnitTileSize;
  testId: string;
  unitName: string;
}): JSX.Element {
  const variant = getVariant(unitName);
  const displayInitials = getAbbreviation(unitName);
  return <Box xcss={cx(boxStyles[size], backgroundColorStyles[variant], isHighlighted ? highlightedBackgroundColorStyles[variant] : undefined, isSandboxUnit ? sandboxUnitStyles.grayscale : undefined)} testId={testId} data-variant={variant}>
			<Box as="span" aria-hidden="true" xcss={textColorStyles[variant]}>
				{displayInitials}
			</Box>
		</Box>;
}
export function UnitTile({
  unitName,
  size,
  iconUrl,
  icons,
  isHighlighted,
  isSandboxUnit,
  testId,
  isIconLoading
}: UnitTileProps): JSX.Element {
  const resolvedTestId = testId ?? FALLBACK_TESTID;
  // Signed icon URLs can expire after rendering; fall back to initials for a failed URL, while allowing a new URL to retry.
  const [failedIconUrl, setFailedIconUrl] = useState<string>();
  // Tracks native image loading
  const [loadedIconUrl, setLoadedIconUrl] = useState<string>();

  // Renditions win when usable, since only they can be matched to the rendered size.
  // Falling through to `iconUrl` keeps callers that have no renditions unchanged.
  const iconSources = resolveIconSources(icons, size);
  const resolvedIconUrl = iconSources.src ?? iconUrl;

  // Keyed off the URL actually rendered, so an expired rendition falls back to
  // initials just as an expired `iconUrl` does.
  const hasFailedImage = failedIconUrl === resolvedIconUrl;
  const displayedIconUrl = hasFailedImage ? undefined : resolvedIconUrl;
  const isImageLoading = Boolean(displayedIconUrl) && loadedIconUrl !== displayedIconUrl;
  const showSkeleton = isIconLoading || isImageLoading;
  if (!displayedIconUrl) {
    if (showSkeleton) {
      return <UnitTileLoadingSkeleton size={size} testId={resolvedTestId} />;
    }
    return <UnitTileAbbreviation unitName={unitName} size={size} isHighlighted={isHighlighted} isSandboxUnit={isSandboxUnit} testId={resolvedTestId} />;
  }
  return <UnitTileImage unitName={unitName} size={size} iconUrl={displayedIconUrl} srcSet={iconSources.srcSet} sizes={iconSources.sizes}
  // Treat a failed image as no icon so the existing initials tile is rendered.
  onError={() => setFailedIconUrl(displayedIconUrl)} onLoad={() => setLoadedIconUrl(displayedIconUrl)} showLoadingState={showSkeleton} isHighlighted={isHighlighted} isSandboxUnit={isSandboxUnit} testId={resolvedTestId} />;
}